<template>
  <div class="">
    <div class="form-constructor__content content">
      <p class="form-constructor__mark">Направление деятельности:</p>
      <Dropdown
        v-if="dropdown"
        :model-value="dataSource.UniversalTagId"
        :options="dataSource.UniversalTags"
        option-label="Description"
        option-value="Id"
        placeholder="Направление деятельности"
        style="width: 100%; height: 46px; margin-bottom: 24px;"
        disabled
      />
      <CascadeSelect
        v-if="cascadeSelect"
        :model-value="dataSource.UniversalTagSubChildId"
        :options="dataSource.UniversalTags"
        optionLabel="Name"
        optionValue="Id"
        optionGroupLabel="Name"
        :optionGroupChildren="['children']"
        style="width: 100%; height: 46px;  margin-bottom: 24px; border: 1px solid #000000 !important; text-align: left;"
        placeholder="Направление деятельности"
        disabled
      />
      <p class="form-constructor__mark">Название товара/новости (H1):</p>
      <InputText
        type="text"
        :value="dataSource.Header"
        placeholder="Заголовок"
        disabled
        style="margin-bottom: 24px;"
      />
      <p class="form-constructor__mark">Краткое описание:</p>
      <Textarea
        :value="dataSource.Synopsis"
        rows="5"
        cols="30"
        placeholder="Краткое описание"
        :auto-resize="true"
        disabled
        style="margin-bottom: 24px;"
      />
      <p class="form-constructor__mark">Краткое описание:</p>

      <div class="content__blocks" v-if="contentBlocks">
        <FormContentBlock
          v-for="(item, idx) in dataSource.ContentBlocks"
          :key="idx"
          :content-block="item"
          :blok-text="item.Text"
          :blok-type="item.Type"
          :images="item.Images"
          :video-url="item.FilePath"
          :front-image-id="dataSource?.FrontImageFileId"
          demo
        />
      </div>

      <div
        class="form-constructor__products-block products-block" v-if="products"
      >
        <FormContentBlock
          v-if="dataSource.Images?.length !== 0"
          blok-type="Image"
          :images="dataSource?.Images"
          :front-image-id="dataSource?.FrontImageFileId"
          demo
        />

        <FormContentBlock
          v-for="(url, idx) in dataSource.Videos"
          :key="idx"
          blok-type="Video"
          :video-url="url"
          demo
        />

        <h2 class="products-block__header">Описание:</h2>
        <TextEditorBlock
          :editor-data="dataSource.Description"
        />

        <h2 class="products-block__header">Характеристики:</h2>
        <TextEditorBlock
          :editor-data="dataSource.Characteristics"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'

import FormContentBlock from '@/components/elements/FormContentBlock.vue'
import TextEditorBlock from '@/components/elements/TextEditorBlock.vue'

import Dropdown from 'primevue/dropdown'
import CascadeSelect from 'primevue/cascadeselect'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'

export default {
  name: 'FormConstructorDemo',
  components: {
    Dropdown,
    CascadeSelect,
    InputText,
    Textarea,
    FormContentBlock,
    TextEditorBlock
  },
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    products: {
      type: Boolean,
      default: false
    },
    cascadeSelect: {
      type: Boolean,
      default: false
    },
    dropdown: {
      type: Boolean,
      default: false
    },
    contentBlocks: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const envUrlBase = process.env.VUE_APP_URL_BASE + '/'

    const activities = reactive([
      { name: 'Группа компаний', Id: 1 },
      { name: 'Обучение', Id: 2 },
      { name: 'Производство', Id: 3 },
      { name: 'Инжиниринговые услуги', Id: 4 },
      { name: 'Программное обеспечение', Id: 5 }
    ])

    return {
      activities,
      envUrlBase
    }
  }
}
</script>

<style lang="scss" scoped>
.form-constructor {
  // display: flex;
  // align-items: start;
  // justify-content: space-between;
  // height: 100%;

  &__spinner {
    @include flex-center;
  }

  &__mark {
    margin-bottom: 8px;
    text-align: start;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.02em;
    font-feature-settings: 'calt' off;
    color: #848484;
  }

  &__content {
    display: flex;
    flex-direction: column;
    // width: 60%;
    background-color: #FFFFFF;
  }

  &__controllers {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    gap: 15px;
  }
}

.products-block {
  &__header {
    color: #000000;
    padding: 5px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
  }
}
.p-dropdown {
  background-color: #F5F5F5;
  border: 1px solid #C8C8C8;
  border-radius: 6px;
  text-align: left;

  height: 42px;
  padding: 5px;
}
.p-disabled {
  opacity: 0.5;
}
:deep(.p-dropdown) {
  &.p-focus {
    box-shadow: none !important;
    outline: none; /* опционально: убрать outline, если тоже мешает */
  }

  &:focus-visible {
    box-shadow: none !important;
    outline: none;
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}
.p-inputwrapper-filled {
  //color: #000000 !important;
  &:hover {
    //background-color: #0080B1 !important;
    //color: #FFFFFF !important;
    //fill: #FFFFFF !important;
  }
}
:deep(.p-dropdown) {
  &.p-inputwrapper-filled {
    .p-dropdown-clear-icon,
    .p-dropdown-trigger,
    .p-dropdown-label,
    .p-dropdown-item .p-checkbox .p-checkbox-box,
    .p-dropdown-item .p-checkbox .p-checkbox-icon {
      &:hover {
        //color: #FFFFFF !important;
      }
    }
  }
}

:deep(.p-inputtext) {
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
